// ProtectedRoute.jsx
import React from "react";
import { Navigate } from "react-router-dom";

const ProtectedRoute = ({ element: Component, allowedRoles, userRole }) => {
  // If user role is not allowed, redirect to unauthorized or login
  if (!allowedRoles.includes(userRole) || userRole === null) {
    return <Navigate to="/unauthorized" replace />;
  }

  return <Component />;
};

export default ProtectedRoute;
